import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import DateAdapter from '@mui/lab/AdapterDayjs';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import dayjs from 'dayjs';

const TemporaryHousingCompleteDialog = (props) => {
  const { onClose, open } = props;
  const [completeDate, setCompleteDate] = React.useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const dateChangeHandler = (newDate) => {
    setCompleteDate(newDate);
    setErrorMessage('');
  };

  const handleOk = () => {
    if (!completeDate) {
      setErrorMessage('Please enter the complete date.');
    } else if (dayjs(completeDate).isValid()) {
      onClose(dayjs(completeDate).format('YYYY-MM-DD'), true);
    } else {
      setErrorMessage('Please enter valid complete date.');
    }
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>Complete Temporary Housing</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={0.5}>
          {props.Contact && (
            <>
              <Grid item xs={3} style={{ marginBottom: '1em' }}>
                <Typography color="text.secondary">Student</Typography>
              </Grid>
              <Grid item xs={9} style={{ marginBottom: '1em' }}>
                <Typography>{props.Contact.Name}</Typography>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={DateAdapter}>
              <MobileDatePicker
                clearable
                label="Date Completed"
                inputFormat="MM/DD/YYYY"
                value={completeDate}
                onChange={dateChangeHandler}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    error={errorMessage.length > 0}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <DialogContentText style={{ color: 'red' }}>
          {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export { TemporaryHousingCompleteDialog };
